import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { gpsDetailsColumn } from '@veritas-dumpsters/constants/gps-details-column.const';
import { DumpsterSitGis, ICoordinationDetailsRow } from '@veritas-dumpsters/models/coordination-details-row';
import { DumpsterGpsInfo, ParametersCommand } from '@veritas-dumpsters/models/dumpster-gps-info';
import { DumpsterGpsInfoService } from '@veritas-dumpsters/services/dumpster-gps-info.service';
import { DateFormat } from '@veritas-shared/enums/date.enum';
import { ConstantHelper } from '@veritas-shared/helpers/constant.helper';
import { Dumpster } from '@veritas-shared/models/dumpster';
import { GridColumn } from '@veritas-shared/models/grid-column';
import { ConversionDistanceService } from '@veritas-shared/services/conversion-distance.service';
import { DateService } from '@veritas-shared/services/date.service';
import { BeanDialogComponentBase } from 'bean-kendo-dialog';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-detail-gps-dialog',
  templateUrl: './detail-gps-dialog.component.html',
  styleUrls: ['./detail-gps-dialog.component.scss'],
})
export class DetailGpsDialogComponent extends BeanDialogComponentBase<Dumpster> implements OnInit, OnDestroy {
  @ViewChild('templateGps', { static: true })
  public templateGps!: TemplateRef<any>;
  @ViewChild('templateSitGis', { static: true })
  public templateSitGis!: TemplateRef<any>;

  public columns: GridColumn[] = [];
  public items: ICoordinationDetailsRow[] = [];
  public distance?: string;
  public gpsLastSent?: string;
  public dumpsters: DumpsterSitGis[] = [];

  constructor(
    public constantHelper: ConstantHelper,
    private infoService: DumpsterGpsInfoService,
    private distanceService: ConversionDistanceService,
    private dateService: DateService
  ) { super(); }

  ngOnInit(): void {
    this._setTableColumn();
    this.infoService.setDumpsterId(this.data?.deviceExternalId);
  }

  ngOnDestroy(): void {
    this.gpsInfo$.unsubscribe();
  }

  ngAfterViewInitCallback(): void { }
  
  public cancel = (e: any): boolean => true;
  public back = (e: any): boolean => true;
  public save = (e: any): Observable<ParametersCommand<string>> => {
    const command: ParametersCommand<string> = this.infoService.getCommandPayload();
    return of(command)
  };

  public setSave = () => { this.saveButtonClick() }
  public setCancel = () => { this.backButtonClick() }

  public getPinByColumn = (column: GridColumn): string => {
    return this.infoService.getPinIcon(column?.field === 'sitGis');
  }

  public getPinByDumpster = (dumpster: DumpsterSitGis): string => {
    return this.infoService.getPinIcon(Boolean(dumpster?.isSitGis))
  }

  private _setItems = (dumpster: Dumpster, details?: DumpsterGpsInfo) => {
    this.items = this.infoService.getDumpsterRow(details);
    this.dumpsters = this.infoService.getMapPins(dumpster, details);
    this.gpsLastSent = this.dateService.getFormat(details?.lastCommandSent, DateFormat.defaultDate);
    this.distance = this.distanceService.getBest(details?.gpsDistanceMeters * 1000);
  }

  private _setTableColumn = () => {
    const config = new gpsDetailsColumn();
    this.columns = [
      config.gps(this.templateGps),
      config.sitGis(this.templateSitGis)
    ]
  }

  private gpsInfo$ = this.infoService.dumpsterData$.subscribe({
    next: (details: DumpsterGpsInfo) => { this._setItems(this.data, details); },
    error: () => { this._setItems(this.data, null); }
  })
}
